import ComputerIcon from '@mui/icons-material/Computer'
import { IconProps } from './iconBase'

/** Web予約受付可否用アイコン */
export const AcceptWebReservationIcon = (props: IconProps) => {
  return <ComputerIcon {...props} />
}
